export async function pingServer(timeoutSeconds?: number): Promise<boolean> {
	// AbortSignal.timeout is intentionally avoided: it is missing on older Android
	// WebViews (Chrome < 103), and throwing here leaves react-query stuck offline.
	const controller = new AbortController();
	const timeoutId = timeoutSeconds
		? setTimeout(() => controller.abort(), timeoutSeconds * 1000)
		: undefined;
	try {
		const res = await fetch(
			"https://api.crm.villagecaregiving.com/api/health",
			{
				signal: controller.signal,
			},
		);
		return res.ok;
	} catch {
		return false;
	} finally {
		clearTimeout(timeoutId);
	}
}
